import React, { useState, useEffect } from 'react';
import { onAuthStateChanged, isAdmin } from '../../firebase/authService';
import AdminLogin from './AdminLogin';

const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isUserAdmin, setIsUserAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(async (user) => {
      setUser(user);
      
      if (user) {
        // Check admin status using server-side validation
        const adminStatus = await isAdmin(user);
        setIsUserAdmin(adminStatus);
      } else {
        setIsUserAdmin(false);
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleLoginSuccess = () => {
    // The onAuthStateChanged listener will automatically update the user state
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!user || !isUserAdmin) {
    return <AdminLogin onLoginSuccess={handleLoginSuccess} />;
  }

  return children;
};

export default ProtectedRoute;
